<script>
	import uniqueId from '../scripts/helpers/uniqueId.js';
	import controller from "../scripts/controller/controller.js";
	import fileFromBase64 from "../scripts/helpers/fileFromBase64.js";
	export default {
		props: {
			field: {
				type: Object,
				default: null
			}
		},
		emits: [
			'fileinput',
			'fileremove'
		],
		data() {
			return {
				localFile: null,
				localErrors: [],
				rerenderKey: 0,
				croppParams: null
			}
		},
		methods: {
			getKey() {
				return uniqueId();
			},
			fileInput(e) {
				const newKey = this.getKey();

				// always 1 file per event! (no multiple <input>)
				if (e.target.files?.length) {
					// const files = Array.from(e.target.files);

					this.localErrors = [];
					if (this.field.maxSize && e.target.files[0].size > this.field.maxSize) {
						this.localErrors.push('Файл превышает максимальный размер');
					} else if (e.target.files[0].type.indexOf('image') < 0) {
						this.localErrors.push('Допускаются только файлы картинок');
					}

					if (this.localErrors.length) {
						return;
					}

					this.remove();

					this.localFile = {
						name: e.target.files[0].name,
						size: e.target.files[0].size,
						key: newKey
					};

					// FileReader support
					if (FileReader) {
						const fr = new FileReader();
						fr.readAsDataURL(e.target.files[0]);
						e.target.files[0].key = newKey;
						fr.onload = () => {
							this.localFile.image = fr.result;
							this.openModal()
						};
					}
					// e.key = newKey;
					// this.$emit('fileinput', e);
				}

				this.rerenderKey = this.getKey();

			},
			remove() {
				this.localErrors = [];
				if (this.localFile) {
					this.$emit('fileremove', [this.localFile, 'avatar']);
					this.localFile = null;
					// fetch('/settings/?clear_avatar=Y');
				}
			},
			initLocalValueFromValue(initial) {
				this.localErrors = [];

				if (this.field.files && initial) {
					let newKey = this.getKey();

					console.log(this.field.files[this.field.files.length - 1])
					// передаётся только path

					this.localFile = {
						name: this.field.files[this.field.files.length - 1].name,
						size: this.field.files[this.field.files.length - 1].size,
						path: this.field.files[this.field.files.length - 1].path,
						image: this.field.files[this.field.files.length - 1].image || this.field.files[this.field.files.length - 1].path,
						key: this.field.files[this.field.files.length - 1].key || newKey,
					};
					this.$emit('fileinput', {
						target: {files: [this.field.files[this.field.files.length - 1]]}
					});
				} else if (!this.field.files && !initial) {
					this.localFile = null;
				}
			},

			setCroppParams(data) {
				let newKey = this.getKey();
				this.localFile.image = data.img
				this.localFile.key = newKey
				this.croppParams = data.params

				const file = [fileFromBase64(this.localFile.image, this.localFile.name)]
				file[0].key = newKey

				this.$emit('fileinput', {
					target: {
						files: file}
				});
			},

			openModal() {
				if(this.localFile){
					controller.openModal({
						component: {
							name: "v-cropp-image",
							props: {
								dataSource: {
									...this.field?.modalCroppProps,
									className: this.field?.className,
									image: this.localFile.image,
									croppParams: this.croppParams
								}
							},
							listeners: {
								'setCroppedImage': async (data) => {
									this.setCroppParams(data)
								},
							}
						}
					});
				}
			},
		},
		watch: {
			field() {
				this.initLocalValueFromValue(true);
			}
		},
		mounted() {
			this.initLocalValueFromValue(true);
		}
	}
</script>

<template lang="pug">
.v-field-avatar.field-avatar(:class="field.className")
	.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	input.field-avatar__input(type="file" @change="fileInput" :key="rerenderKey" ref="input" tabindex="-1")
	.field-avatar__layout
		button.field-avatar__visual(
				:class="{'full': localFile?.image}"
				type="button"
				tabindex="-1"
				@click="$refs['input'].click()"
				@keydown.enter="$refs['input'].click()")
			img.field-avatar__image(v-if="localFile?.image"
				:src="localFile.croppedImage ? localFile.croppedImage : localFile.image" alt="")
			.field-avatar__ph(v-else)
				v-svg-icon.field-avatar__ph-icon(icon="profile")
		.field-avatar__main
			.field-avatar__actions
				.field-avatar__action(v-if="field.addButton && !localFile" )
					v-svg-icon.field-avatar__action-icon(v-if="field.addButton.icon" :icon="field.addButton.icon" )
					button.field-avatar__action-link(
							v-if="field.addButton"
							type="button"
							@click="$refs['input'].click()"
							@keydown.enter="$refs['input'].click()")
							| {{ field.addButton.text }}
				.field-avatar__action(v-if="field.removeButton && localFile" :class="field.removeButton?.className")
					v-svg-icon.field-avatar__action-icon(v-if="field.removeButton.icon" :icon="field.removeButton.icon" )
					button.field-avatar__action-link.field-avatar__action-link--remove(
							v-if="field.removeButton && localFile"
							type="button"
							@click="remove")
							| {{ field.removeButton.text  }}
		.field-avatar__note(v-if="field.note" ) {{ field.note }}
	.field-avatar__errors.flc(v-if="localErrors?.length")
			.error-list.flc
				.error-list__item.error-message.flc(v-for="(error, index) in localErrors" :key="index") {{ error }}
</template>